import { axiosClient } from '@/libs/axios-client';

const API_BASE = '/suppliers';

// ============================================
// Suppliers („Dobavljači"): the company's suppliers from its incoming invoices
// ============================================

/** Companies whose suppliers the user may list. @returns {Promise<Array<{_id, name}>>} */
export const getCompanies = async () => {
  const response = await axiosClient.get(`${API_BASE}/companies`);
  return response.data.data;
};

/** One page of suppliers. @param {Object} params - { search?, sort?, order?, offset, limit } */
export const getSuppliers = async (companyId, params) => {
  const response = await axiosClient.get(`${API_BASE}/${companyId}`, { params });
  return response.data.data;
};

/** One supplier's profile data (invoice data, books partner, contact block). */
export const getSupplier = async (companyId, pib) => {
  const response = await axiosClient.get(`${API_BASE}/${companyId}/${encodeURIComponent(pib)}`);
  return response.data.data;
};

/** The supplier's incoming invoices, newest first. */
export const getInvoices = async (companyId, pib, params) => {
  const response = await axiosClient.get(`${API_BASE}/${companyId}/${encodeURIComponent(pib)}/invoices`, { params });
  return response.data.data;
};

/** Bank statement payments applied to the supplier's invoices. */
export const getPayments = async (companyId, pib, params) => {
  const response = await axiosClient.get(`${API_BASE}/${companyId}/${encodeURIComponent(pib)}/payments`, { params });
  return response.data.data;
};

/** Users of the company who may follow a supplier. @returns {Promise<Array<{_id, name, email}>>} */
export const getPeople = async (companyId) => {
  const response = await axiosClient.get(`${API_BASE}/${companyId}/people`);
  return response.data.data;
};

/** Saves the platform-only contact block. */
export const saveNote = async (companyId, pib, body) => {
  const response = await axiosClient.put(`${API_BASE}/${companyId}/${encodeURIComponent(pib)}/note`, body);
  return response.data.data;
};
